import { render, staticRenderFns } from "./LogoImprovementRequestSuccessModal.vue?vue&type=template&id=23c37f4c"
import script from "./LogoImprovementRequestSuccessModal.vue?vue&type=script&lang=js"
export * from "./LogoImprovementRequestSuccessModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./LogoImprovementRequestSuccessModal.vue?vue&type=style&index=0&id=23c37f4c&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports